import {Component} from "@angular/core";
import {SupplierSearchModel} from "../supplier-search.model";
import {SupplierEntityModel} from "../supplier-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-supplier-search-page",
    templateUrl: "./supplier-search-page.component.html",
    providers: [provideSearchModel(SupplierSearchModel), provideEntityModel(SupplierEntityModel)]
})
export class SupplierSearchPageComponent extends AbstractSearchPage {
    constructor (public model: SupplierSearchModel) {
        super();
    }
}
